<template>
  <div>
    <div
      class="tw-flex tw-flex-col tw-mx-auto tw-gap-5 tw-max-w-[768px]"
    >
      <div class="tw-text-left">
        <h2 class="question-title-v2 tw-mb-4">
          {{ question.title }}
        </h2>
        <p class="sub-text group-mb tw-mb-6">
          {{ question.question }}
        </p>
      </div>

      <div
        v-if="question.answerlist.length === 1"
        class="tw-flex tw-justify-center"
      >
        <b-button
          class="tw-px-6"
          variant="info"
          size="md"
          @click="onSelect(question.answerlist[0])"
        >
          {{ question.answerlist[0].name }}
        </b-button>
      </div>
      <div
        v-else-if="question.answerlist.length > 1"
        class="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-max-w-[420px] tw-mx-auto"
      >
        <button
          v-for="(item, i) in question.answerlist"
          :key="item.id + '-' + i"
          type="button"
          class="tw-w-full tw-py-3 tw-px-4 tw-rounded-lg tw-border tw-bg-white tw-text-gray-900 tw-text-sm tw-transition-colors hover:tw-border-gray-500"
          :class="isSelected(item) ? 'tw-border-gray-700' : 'tw-border-gray-300'"
          @click="onSelect(item)"
        >
          {{ item.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      selected: null,
      text: '',
    };
  },
  watch: {
    question() {
      this.selected = null;
      this.text = '';
    },
  },
  methods: {
    isSelected(item) {
      return this.selected && this.selected.id === item.id;
    },
    onSelect(item) {
      this.selected = item;
      this.text = '';
      this.$emit('submitAnswer', {
        id: this.question.id,
        answer: item.id,
        answerBody: item
      });
    },
  },
};
</script>
